import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

// The server answers 200 for every app URL (SPA), so noindex is what keeps
// unknown URLs out of Google.
export default function NotFound() {
  return (
    <div className="max-w-xl mx-auto px-4 py-32 text-center">
      <Helmet>
        <title>Page not found | The BakeNook</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <h1 className="text-3xl md:text-4xl text-gray-900 mb-4">Page not found</h1>
      <p className="text-gray-600 mb-8">This page does not exist, or it has moved.</p>
      <Link to="/" className="hover:text-coral-500 transition-colors underline">Back to the home page</Link>
    </div>
  )
}
